import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { resendOTP, sendOTP, verifyOTP } from '../indexApi';
import useCustomerData from '../../LandingPage/Hooks/useCustomerData';

const useLoginData = () => {
  const { handleLoginSuccess } = useCustomerData();
  const [loading, setLoading] = useState(false);
  const [alertMsg, setAlertMsg] = useState({
    type: null,
    msg: null,
  });
  const [errMsg, setErrMsg] = useState(null);
  const [showErr, setShowErr] = useState(false);
  const [number, setNumber] = useState(null);

  const [otpSent, setOtpSent] = useState(false);

  const [otp, setOtp] = useState('');
  const [seconds, setSeconds] = useState(0);
  const [urt, setUrt] = useState('');

  let history = useHistory();
  let location = useLocation();

  const onMobileNumberChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setNumber(value);
    } else {
      return;
    }
  };

  const onSendOtpClick = async (isReset) => {
    if (isReset) {
      setUrt('');
      setOtpSent(!otpSent);
      setOtp('');
    } else {
      setLoading(true);
      const payload = {
        platform: 'FALCON',
        mobileNbr: number,
      };
      const data = await sendOTP(payload);
      if (data?.data?.status === 'SUCCESS') {
        setUrt(data?.data?.urt);
        setOtpSent(!otpSent);
        setSeconds(30);
        setOtp('');
        setErrMsg(null);
      } else {
        alert('Error while login. Try after sometime.');
      }
      setLoading(false);
    }
  };

  const onResendOtp = async () => {
    setLoading(true);
    const payload = {
      platform: 'FALCON',
      urt: urt,
    };
    const data = await resendOTP(payload);
    if (data?.data?.status === 'SUCCESS') {
      setUrt(data?.data?.urt);
      setSeconds(30);
      setOtp('');
      setErrMsg(null);
    } else {
      alert('Error while login. Try after sometime.');
    }
    setLoading(false);
  };

  const onVerifyOtpClick = async () => {
    setLoading(true);
    const payload = {
      platform: 'FALCON',
      mobileNbr: number,
      urt: urt,
      otp: otp,
    };

    Promise.race([
      verifyOTP(payload),
      new Promise((_, reject) => {
        setTimeout(() => reject(new Error('timeout')), 5000);
      }),
    ])
      .then((res) => {
        handleLoginSuccess(null, res?.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err?.response?.data?.message === 'Error Verifying OTP. Please try again later') {
          setErrMsg('Incorrect OTP');
          setShowErr(true);
          setLoading(false);
        } else {
          setErrMsg('Incorrect Mobile Number OR OTP');
          setShowErr(true);
          setLoading(false);
          // history.push('/store', { type: 'OTP-Login', mobileNumber: number });
          // setLoading(false);
        }
      });
  };

  const onSignupWithGoogle = () => {
    console.log('Goooogle');
  };

  const handleErrorClose = () => {
    setShowErr(false);
  };

  return {
    onMobileNumberChange,
    number,
    otpSent,
    onSendOtpClick,
    otp,
    setOtp,
    onVerifyOtpClick,
    onSignupWithGoogle,
    loading,
    errMsg,
    handleErrorClose,
    showErr,
    seconds,
    setSeconds,
    onResendOtp,
  };
};

export default useLoginData;
